import { render, staticRenderFns } from "./SpacerBlock.vue?vue&type=template&id=db2e4028&scoped=true&"
import script from "./SpacerBlock.vue?vue&type=script&lang=js&"
export * from "./SpacerBlock.vue?vue&type=script&lang=js&"
import style0 from "./SpacerBlock.vue?vue&type=style&index=0&id=db2e4028&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2e4028",
  null
  
)

export default component.exports